import { useEffect, useState } from "react";
import { api } from "./api";

export const gbp = (v) => {
  const n = Number(v && typeof v === "object" ? v.amount : v);
  if (!Number.isFinite(n)) return "£—";
  return `£${n.toFixed(n % 1 === 0 ? 0 : 2)}`;
};

export function useStoreProducts() {
  const [state, setState] = useState({ products: [], loading: true, tagline: "", live: false });
  useEffect(() => {
    api.get("/public/store/products")
      .then(({ data }) => setState({ products: data.products, loading: false, tagline: data.tagline, live: data.single_track_live }))
      .catch(() => setState((s) => ({ ...s, loading: false })));
  }, []);
  return state;
}

export function useStoreProduct(slug) {
  const [state, setState] = useState({ product: null, loading: true, missing: false });
  useEffect(() => {
    if (!slug) return;
    setState({ product: null, loading: true, missing: false });
    api.get(`/public/store/products/${slug}`)
      .then(({ data }) => setState({ product: data, loading: false, missing: false }))
      .catch(() => setState({ product: null, loading: false, missing: true }));
  }, [slug]);
  return state;
}
